var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main-wrapper main-wrapper-1"},[_c('div',{staticClass:"navbar-bg"}),_c('navbar'),_c('sidebar'),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }